import script from "./ThuChiLich.vue?vue&type=script&setup=true&lang=js"
export * from "./ThuChiLich.vue?vue&type=script&setup=true&lang=js"

import "./ThuChiLich.vue?vue&type=style&index=0&id=e8ccd8e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8ccd8e6"]])

export default __exports__